export var mobileBreakpoint = 786;
export var isMobileView = function () { return window.outerWidth <= mobileBreakpoint; };
//# sourceMappingURL=isMobileView.js.map